import { Box, Button } from '@mui/material';
import styles from 'assets/styles/modal.module.scss';

type Props = {
  data: any;
  setState: (e: string) => void;
  state: string;
  disabled?: boolean;
};

export default function Toggle({ data, setState, state, disabled }: Props) {
  const handleClick = (i: any) => {
    if (disabled) {
      return;
    }
    setState(i);
  };

  return data?.map((i: any, id: number) => (
    <Button
      disableRipple
      key={i.title + id}
      onClick={() => handleClick(i.value)}
      className={
        disabled
          ? styles.disabled
          : state === i.value
          ? `${styles.btnActive} ${styles.btn}`
          : styles.btn
      }>
      {i.icon} <Box mr='5px' /> {i.title}
    </Button>
  ));
}
